var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"modal-close-button",on:{"click":function($event){$event.preventDefault();return _vm.handleCloseModal($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }